/* eslint-disable consistent-return */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Col, Row, Tooltip,ButtonGroup } from 'reactstrap';

import LockIcon from '../../../Res/Icon/lock.png';
import AddTime from '../../../Res/Icon/addTime.png';
import portActivityIcon from '../../../Res/Icon/portActivityIcon.png';
import Release from '../../../Res/Icon/releaseLock.png';
import UnLockIcon from '../../../Res/Icon/unlocked.png';
import bandManagement from '../../../Res/Icon/bandManagement.png';
import { isAdminRole } from '../../../lib/utils';
import TooltipIcon from './TooltipIcon/TooltipIcon';
import {
  addLockTime,
  boxLock,
  boxLockStatus,
  overrideLock,
  releaseLock,
  fetchAvailableOobBTNs
} from '../../../actions/EpikBoxes';
import { toast } from 'react-toastify';
import { DEVICE_LOCK_BY_SOMEONE, } from '../../../lib/constants';
import { bandModelWindowsOption } from '../../../utils/constants'
import ConfirmationModal from '../../ConfirmationModal';
import { ReactComponent as PortActivity } from '../../../Res/CDR/Search_Analysis.svg';
import { getPermissionForComponent } from '../../../utils/permissionsUtils';
import { ReactComponent as OutBandManagement } from '../../../Res/svg/OOBM.svg';
import { ReactComponent as CalFeatureLogo } from '../../../Res/svg/callFeature.svg';
import TooltipCustom from './TooltipCustom';
import { useUnifiedFetch } from '../../../hooks'
import './RemainingTimer.css';

const RemainingTimer = memo((props) => {
  const { onAnalyticsCall, onBandManagementCall, bandModelWindow, releaseDeviceLock, parentSetState, oobSavedProfiles,CallFeaturesModal } = props;
  const dispatch = useDispatch();
  const realTimeActivity = useSelector(state => state.AppState.user);
  const [dcUpdatePopup, setDcUpdatePopup] = useState({ show: false, value: {} });
  const [portActivityOpen, setPortActivityOpen] = useState(false);
  const [boxLockWarning, setBoxLockWarning] = useState(false);

  const token = localStorage.getItem('jwtToken') || null;

  const lockStatusBox = useSelector(state => state.UIState.epikBoxes.lockStatusEpikBox);
  const boxDetails = useSelector(state => state.AppState.boxDetails.box);
  const engineeringLock = useSelector(state => state.AppState.boxDetails.engineeringLock);
  const user = useSelector(state => state.AppState.user);

  const {
    isLoading,
    data: oobmPortProfiles,
    fetchData: fetchingOobmProfiles
  } = useUnifiedFetch(`oob/${boxDetails?._id}/fetchSavedProfiles`, false);

  const [time, setTime] = useState({
    h: 0,
    m: 0,
    s: 0,
  });
  const [checkTimer, setCheckTimer] = useState(false);

  const [lockBoxStatus, setLockBoxStatus] = useState(false);
  const outBandManagement = getPermissionForComponent('outBandManagement',user.permissionsGroup);
  const callFeatures = getPermissionForComponent('callFeatures',user.permissionsGroup);

  useEffect(() => {
    const lockBoxStatusTag = !lockStatusBox?.locked && !lockStatusBox?.user && !!boxDetails._id;
    setLockBoxStatus(lockBoxStatusTag);

    if (checkTimer) {
      const interval = setInterval(async() => {
        if (time.m === 0 && time.s === 0) {
          clearInterval(interval);
          setCheckTimer(false);
        } else if (time.m === 2 && time.s === 0) {
          if (!engineeringLock && !lockStatusBox?.locked && !!lockStatusBox?.user) {
            // Notify the user when 2 minutes are left
            setDcUpdatePopup({ show: true });
          }
        } else if (time.s === 0) {
          setTime({
            h: 0,
            m: time.m - 1,
            s: 59,
          });
        } else {
          setTime({
            h: 0,
            m: time.m,
            s: time.s - 1,
          });
        }
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [lockStatusBox, boxDetails, checkTimer, time]);

  const updateTimer = seconds => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    setTime({
      h: 0,
      m: minutes,
      s: remainingSeconds,
    });
  };

  const lockStatus = async () => {
    const bid = boxDetails?._id || window.location.pathname.split('/').pop();
    const data = await dispatch(boxLockStatus(token, bid));
    if (data?.timeRemaining) {
      setLockBoxStatus(false);
      setCheckTimer(true);

      updateTimer(data?.timeRemaining || 0);
    }
  };


  const [oob, setOob] = useState(boxDetails.OBEnable);

  useEffect(() => {
    if (boxDetails._id) {
      setOob(boxDetails.OBEnable)
      lockStatus();
    }
  }, [boxDetails]);

  const unLockBoxButton = async (status, showMessage = true) => {
    if (status === 'add') {
      await dispatch(addLockTime(token, boxDetails._id, showMessage));
      await lockStatus();
    } else if (status === 'release') {
      await dispatch(releaseLock(token, boxDetails._id));
      await lockStatus();
      setLockBoxStatus(true);
    } else {
      await dispatch(overrideLock(token, boxDetails._id));
      await lockStatus();
    }
  };

  const handleBoxLock = async () => {
    // if (user.role === 'enterpriseAdmin') {
    //   return;
    // }
    await dispatch(boxLock(token, boxDetails._id));
    await lockStatus();
  };

  const oobmHander = async () => {
    await onBandManagementCall()
    const saveProfiles = await fetchingOobmProfiles()
    oobSavedProfiles(saveProfiles)
    await dispatch(fetchAvailableOobBTNs(token, boxDetails._id));
  }

  useEffect(() => {
    // increase look time if oob session is open
    if (time.m <= 6 && !lockBoxStatus && bandModelWindow === bandModelWindowsOption.ttyShell) {
      console.log('time is les than 6', time);
      unLockBoxButton('add', false);
      setCheckTimer(true);
    }

    if (checkTimer) {
      const interval = setInterval(async() => {
        if (time.m === 0 && time.s === 0) {
          clearInterval(interval);
          setCheckTimer(false);
        } else if (time.s === 0) {
          setTime({
            h: 0,
            m: time.m - 1,
            s: 59,
          });
        } else {
          setTime({
            h: 0,
            m: time.m,
            s: time.s - 1,
          });
        }
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [checkTimer, time]);

  useEffect(() => {
    if (time.m === 0 && time.s === 0) {
      setLockBoxStatus(true);
      setDcUpdatePopup({ show: false });
      if (lockStatusBox) lockStatusBox.user = null;
    }
  }, [checkTimer, time]);

  const toggle = () => setPortActivityOpen(!portActivityOpen);

  const isESeries = boxDetails?.serialNumber && boxDetails?.serialNumber?.startsWith('E-')

  return (
    <Row className="lock-row-container">
      <Col className="lock-icon text-center" xs={6} md={5}>
        <img
          id="test-lock-icon"
          style={{
            height: '30px',
            cursor: user.role === 'enterpriseAdmin' ? 'default' : lockBoxStatus ? 'pointer' : 'default',
          }}
          src={lockBoxStatus ? UnLockIcon : LockIcon}
          alt="..."
          onClick={() => (lockBoxStatus ? handleBoxLock() : null)}
        />
        <div
          className="text-center pl-1"
          id="test-time-remaining"
          hidden={(time.m < 1 && time.s < 1) || lockBoxStatus}
        >
          <b>Time Remaining</b>
          <br />
          <b>
            {time?.m}min {`0${time?.s}`.slice(-2)}sec
          </b>
        </div>
        {!engineeringLock && !lockStatusBox?.locked && !!lockStatusBox?.user && (
          <>
            <TooltipIcon
              tipId="add-time-icon"
              onClick={() => {
                unLockBoxButton('add');
                setCheckTimer(true);
              }}
              imgSrc={AddTime}
              displayData="Add Lock Time"
              placement="top"
            />
            <TooltipIcon
              tipId="release-lock-icon"
              onClick={() => unLockBoxButton('release')}
              imgSrc={Release}
              displayData="Release Lock"
              placement="top"
            />
          </>
        )}
      </Col>
      {lockStatusBox?.locked && (
        <Col md={3} className="lock-container">
          <h1 className="locked-text">
            Locked by{' '}
            {lockStatusBox?.user}
          </h1>
        </Col>
      )}
      {engineeringLock && (
        <Col md={3} className="lock-container">
          <h1 className="locked-text">Engineering Lock Enabled</h1>
        </Col>
      )}
      <Col md={isESeries ? 1 : oob ? 3 : 2} xs={12}  className="d-flex justify-content-end align-items-center">
        {
          boxDetails?.OBEnable && !isESeries && outBandManagement && (
            <>
              <Button
                id="band-activity"
                className="ml-3 icon-btn"
                aria-label="Out of Band Management"
                onClick={() => {
                  if (lockStatusBox?.locked) {
                    toast.error(DEVICE_LOCK_BY_SOMEONE)
                  } else if (document.getElementById('test-time-remaining')?.hasAttribute('hidden')) {
                    setBoxLockWarning(true);
                  } else {
                    oobmHander();
                  }
                }}
              >
                <OutBandManagement
                  className="cursor-pointer ml-3"
                  width={30}
                  height={30}
                  aria-hidden="true"
                  focusable="false"
                />
              </Button>

              <TooltipCustom
                tipId="band-activity"
                displayData="Out of Band Management"
                placement="top"
              />
            </>
          )
        }
        {
          !isESeries && 
          <>
            <Button
              id="port-activity"
              className="ml-3 icon-btn"
              onClick={onAnalyticsCall}
              aria-label="Real Time Port Activity"
            >
              <PortActivity
                className="cursor-pointer ml-3"
                width={30}
                height={30}
                aria-hidden="true"
                focusable="false"
              />
            </Button>

            <Tooltip
              delay={0}
              placement='top'
              isOpen={portActivityOpen}
              target='port-activity'
              toggle={toggle}
            >
              Real Time Port Activity
            </Tooltip>
          </>
        }
      {/* call feature */}
        <>
        {callFeatures === 'write' || callFeatures === 'both' && (
        <Button
              id="call-feature"
              className="ml-3 icon-btn"
              aria-label="Call Feature"
              onClick={() => {
                if (lockStatusBox?.locked) {
                  toast.error(DEVICE_LOCK_BY_SOMEONE)
                } else if (document.getElementById('test-time-remaining')?.hasAttribute('hidden')) {
                  setBoxLockWarning(true);
                } else {
                  CallFeaturesModal();
                }
              }}
            >
          <CalFeatureLogo
            id="call-feature"
            className="cursor-pointer ml-3"
            width={30}
            height={30}
          />
          <TooltipCustom
            tipId="call-feature"
            displayData="Call Features"
            placement="top"
          />
          </Button>
          )}
        </>
      </Col>

      {lockStatusBox?.canOverride && lockStatusBox?.locked && (
        <Col md={3} className="lock-container">
          <Button
            className="reload-epi-btn"
            color="primary"
            onClick={() => unLockBoxButton('override')}
          >
            Override Lock
          </Button>
        </Col>
      )}
      <ConfirmationModal
        bodyText={
          'The lock will be released in two minutes. Do you want to add more time?'
        }
        confirmBtnText={'Continue'}
        isOpen={dcUpdatePopup.show}
        onCancel={() => {
          setDcUpdatePopup({ show: false, value: {} });
        }}
        onConfirm={() => {
          unLockBoxButton('add');
          setCheckTimer(true);
          setDcUpdatePopup({ show: false, value: {} });
        }}
      />
      {boxLockWarning && (
        <ConfirmationModal
          bodyText="You are attempting to make changes to a device that is not currently locked for editing. To prevent conflicting changes, please lock the device before proceeding."
          headerText="Device Lock Required"
          confirmBtnText="Lock & Edit"
          close="No"
          isOpen={boxLockWarning}
          onCancel={() => setBoxLockWarning(false)}
          onConfirm={() => {
            handleBoxLock();
            setBoxLockWarning(false);
          }}
        />
      )}
    </Row>
  );
});

export default RemainingTimer;
